<template>
  <div>
    <MasterLayout>
      <div class="new-staff">
        <div class="add_new_bank_account_header">
          <p>
            {{ $t("text.cUsers.userDetails.title") }} ({{ $route.query.name }})
          </p>
        </div>
        <div class="cover">
          <div class="personal">
            <div class="row">
              <div class="mt-4 input__group__block col-md-6">
                <label class="required">
                  <span class="mylabel">
                    {{ $t("text.editStaff.firstName") }}
                  </span>
                </label>
                <div class="price_change_input_wrapper">
                  <input
                    type="text"
                    :placeholder="this.$t('text.editStaff.firstName')"
                    v-model="userDetails.firstName"
                    class="border-0"
                  />
                </div>
              </div>
              <div class="mt-4 input__group__block col-md-6">
                <label class="required">
                  <span class="mylabel">
                    {{ $t("text.editStaff.lastName") }}
                  </span>
                </label>
                <div class="price_change_input_wrapper">
                  <input
                    type="text"
                    :placeholder="this.$t('text.editStaff.lastName')"
                    class="border-0"
                    v-model="userDetails.lastName"
                  />
                </div>
              </div>
              <div class="mt-4 input__group__block col-md-6">
                <label class="required">
                  <span class="mylabel">
                    {{ $t("text.cUsers.createUser.phone") }}
                  </span>
                </label>
                <div class="price_change_input_wrapper">
                  <input
                    type="text"
                    :placeholder="$t('text.cUsers.createUser.phone')"
                    v-model="userDetails.phoneNumber"
                    class="border-0"
                  />
                </div>
              </div>
              <div class="mt-4 input__group__block col-md-6">
                <label class="required">
                  <span class="mylabel"> {{ $t("text.cUsers.status") }}</span>
                </label>
                <div class="d-flex align-items-center" style="height: 50px">
                  <select v-model="userDetails.status">
                    <option value="Active">
                      {{ $t("text.cUsers.userDetails.active") }}
                    </option>
                    <option value="Deactivated">
                      {{ $t("text.cUsers.userDetails.deactivate") }}
                    </option>
                    <option value="Suspended">
                      {{ $t("text.cUsers.userDetails.suspend") }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="mt-4 col-md-6">
                <label class="required">
                  <span class="mylabel">
                    {{ $t("text.cUsers.createUser.selectAccess") }}
                  </span>
                </label>
                <div class="price_change_input_wrapper">
                  <select v-model="groupId" @change="replaceSel">
                    <option value="select access level" disabled selected>
                      {{ $t("text.cUsers.createUser.selectAccess") }}
                    </option>
                    <option
                      :value="group.name"
                      v-for="(group, i) in groups"
                      :key="i"
                    >
                      {{ group.name }}
                    </option>
                  </select>
                </div>
              </div>
              <!-- <div
                class="mt-4 col-md-6"
                v-if="userDetails.branchRoles.length && groupId == 'Branch'"
              >
                <label class="">
                  <span class="mylabel">
                    {{ userDetails.branchRoles[0].role }}
                  </span>
                </label>
                <div
                  class="mt-2 display-flex align-items-center justify-content-between"
                >
                  <button class="mr-3 btn btn-info" :disabled="true">
                    {{ userDetails.branchRoles[0].branchName }}
                    <img
                      src="@/assets/img/git_loader.gif"
                      style="display: none"
                      width="23px"
                      class="ml-3 loader1"
                    />
                  </button>
                  <i
                    class="mr-2 cursor-pointer fa fa-minus-square-o"
                    style="font-size: 28px"
                    aria-hidden="true"
                    v-b-tooltip.hover
                    :title="`Remove user `"
                    @click="removeUser"
                  ></i>
                </div>
              </div> -->
              <div class="mt-4 col-md-6" v-if="groupId !== 'Company'">
                <label class="required">
                  <span class="mylabel">
                    {{ $t("text.cUsers.createUser.select") }} {{ groupId }}
                  </span>
                </label>
                <!-- <label class="required" v-if="groupId == 'Branch'">
                  <span class="mylabel"> Select Branch </span>
                </label>
                <label class="required" v-if="groupId == 'Dealers'">
                  <span class="mylabel"> Select Dealer </span>
                </label>
                <label class="required" v-if="groupId == 'Regional Manager'">
                  <span class="mylabel"> Select Region </span>
                </label>
                <label class="required" v-if="groupId == 'Regional Engineer'">
                  <span class="mylabel"> Select Regional Engineer </span>
                </label>
                <label class="required" v-if="groupId == 'Sales Rep'">
                  <span class="mylabel"> Select Sales Rep </span>
                </label> -->
                <!-- main shown select -->
                <div
                  class="price_change_input_wrapper"
                  v-if="
                    replaceSelect == false ||
                    groupId == userDetails.rolesCategory
                  "
                >
                  <!-- <select v-model="newId"> -->
                  <select v-model="userDetails.ownerId">
                    <option value="Please Select" disabled selected>
                      {{ $t("text.cUsers.createUser.select") }} {{ groupId }}
                    </option>
                    <!-- <option
                      value="Please Select"
                      disabled
                      selected
                      v-if="groupId == 'Branch'"
                    >
                      Select Branch
                    </option>
                    <option
                      value="Please Select"
                      disabled
                      selected
                      v-if="groupId == 'Dealers'"
                    >
                      Select Dealer
                    </option>
                    <option
                      value="Please Select"
                      disabled
                      selected
                      v-if="groupId == 'Regional Manager'"
                    >
                      Select Region
                    </option>
                    <option
                      value="Please Select"
                      disabled
                      selected
                      v-if="groupId == 'Regional Engineer'"
                    >
                      Select Regional Engineer
                    </option>
                    <option
                      value="Please Select"
                      disabled
                      selected
                      v-if="groupId == 'Sales Rep'"
                    >
                      Select Sales Rep
                    </option> -->
                    <option
                      :value="cList.id"
                      v-for="(cList, i) in categoryLists"
                      :key="i"
                    >
                      {{ cList.name }}
                    </option>
                  </select>
                </div>
                <!-- second replacement -->
                <div class="price_change_input_wrapper" v-else>
                  <select v-model="newId">
                    <!-- <select v-model="userDetails.ownerId"> -->
                    <option value="Please Select" disabled selected>
                      {{ $t("text.cUsers.createUser.select") }} {{ groupId }}
                    </option>
                    <!-- <option
                      value="Please Select"
                      disabled
                      selected
                      v-if="groupId == 'Branch'"
                    >
                      Select Branch
                    </option>
                    <option
                      value="Please Select"
                      disabled
                      selected
                      v-if="groupId == 'Dealers'"
                    >
                      Select Dealer
                    </option>
                    <option
                      value="Please Select"
                      disabled
                      selected
                      v-if="groupId == 'Regional Manager'"
                    >
                      Select Region
                    </option>
                    <option
                      value="Please Select"
                      disabled
                      selected
                      v-if="groupId == 'Regional Engineer'"
                    >
                      Select Regional Engineer
                    </option>
                    <option
                      value="Please Select"
                      disabled
                      selected
                      v-if="groupId == 'Sales Rep'"
                    >
                      Select Sales Rep
                    </option> -->
                    <option
                      :value="cList.id"
                      v-for="(cList, i) in categoryLists"
                      :key="i"
                    >
                      {{ cList.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="pl-0 mt-3 col-md-6">
              <div class="d-flex align-items-center" style="height: 50px">
                <span class="mr-3 mylabel primary-color">
                  {{ $t("text.cUsers.userDetails.forcePassword") }}
                </span>
                <input
                  type="checkbox"
                  class="border-0"
                  v-model="forcePasswordChange"
                />
              </div>
            </div>
          </div>
          <pulse-loader
            size="15px"
            v-if="groupRolesLoader"
            class="py-5"
          ></pulse-loader>
          <div class="mt-3">
            <div class="mt-4" v-if="showList">
              <label>Roles</label>
              <div class="price_change_input_wrapper">
                <div @click="toggleBranchListDropdown" style="padding: 5px">
                  <vue-tags-input
                    v-model="tag"
                    :tags="tags"
                    @tags-changed="(newTags) => (tags = newTags)"
                  />
                </div>

                <div class="">
                  <div class="search__wrapper">
                    <div class="row align-items-center">
                      <div class="col-md-10">
                        <input
                          type="text"
                          :placeholder="$t('text.iUsers.search')"
                          v-model="searchInp"
                          name="search"
                        />
                      </div>
                      <div class="text-right col-md-2">
                        <i
                          class="mr-3 fa fa-search"
                          aria-hidden="true"
                          style="color: #b6b6b6"
                        ></i>
                      </div>
                    </div>
                  </div>
                  <div class="mt-3 row" style="width: 100%; margin: 0 auto">
                    <div class="col-md-4">
                      <div class="d-flex align-items-center" styl="height:50px">
                        <input
                          type="checkbox"
                          class="mr-2"
                          @click="checkAll"
                          id="selectAllCheckbox"
                        />
                        <span class="primary-color"
                          >{{ $t("text.cUsers.userDetails.selectAll") }}s</span
                        >
                      </div>
                    </div>
                  </div>
                  <div
                    class="mt-3 row justify-content-center"
                    style="width: 100%; margin: 0 auto"
                  >
                    <div class="col-md-4">
                      <div class="">
                        <b-form-group
                          label=""
                          v-on:click.native="toggleChckBox($event)"
                        >
                          <b-form-checkbox-group
                            v-model="selected"
                            :options="filteredList"
                            name="flavour-2a"
                            stacked
                          >
                          </b-form-checkbox-group>
                        </b-form-group>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <b-form-group
                        label=""
                        v-on:click.native="toggleChckBox($event)"
                      >
                        <b-form-checkbox-group
                          v-model="selected"
                          :options="filteredList2"
                          name="flavour-2a"
                          stacked
                        >
                        </b-form-checkbox-group>
                      </b-form-group>
                    </div>
                    <div class="col-md-4">
                      <b-form-group
                        label=""
                        v-on:click.native="toggleChckBox($event)"
                      >
                        <b-form-checkbox-group
                          v-model="selected"
                          :options="filteredList3"
                          name="flavour-2a"
                          stacked
                        >
                        </b-form-checkbox-group>
                      </b-form-group>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="pb-4 mt-4 text-center">
            <button
              :disabled="isButtonDisabled ? true : false"
              class="ep-btn ep-primary"
              @click="updateUser($event)"
            >
          {{ $t('text.iUsers.updateUser') }}
            </button>
            <img
              src="@/assets/img/git_loader.gif"
              style="display: none"
              width="35px"
              class="ml-3 loader"
            />
          </div>
        </div>
      </div>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Company/MasterLayout.vue";
import backgroundUrl from "@/assets/img/Credit-card-background-shallow-DOF.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import CompanyUsersTemplate from "@/components/TableTemplates/companyUsers";
import VueTagsInput from "@johmun/vue-tags-input";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Users :: Epump Portal",
  name: "Users",
  components: {
    MasterLayout,
    TableLoader,
    VueTagsInput,
    PulseLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  data() {
    return {
      company: null,
      currentRoleCategory: "",
      currentId: "",
      backgroundUrl,
      accountType: "select account type",
      usersCount: 0,
      status: "Active",
      cardBackgroundUrl,
      groupRolesLoader: false,
      showLoader: false,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["Search"],
      search: { operator: "contains", ignoreCase: true },
      forcePasswordChange: false,
      firstName: null,
      lastName: null,
      phoneNumber: null,
      isButtonDisabled: false,
      funcListLoader: false,
      options: [],
      options2: [],
      options3: [],
      selected: [],
      combinedOptions: [],
      tag: "",
      tags: [],
      searchInp: "",
      selectAll: false,
      selectAllCheckbox: false,
      userDetails: {},
      groups: [],
      categoryLists: [],
      newId: "Please Select",
      showList: false,
      groupId: "select access level",
      userRoles: null,
      groupRoles: null,
      functionList: [],
      showList: false,
      listId: null,
      userBranchName: null,
      branches: null,
      branchName: null,
      isRemoveBtnDisabled: false,
      replaceSelect: false,
      UsersTemplate: function () {
        return {
          template: CompanyUsersTemplate,
        };
      },
    };
  },
  created() {
    this.userId = this.$route.query.username;
    let ml = sessionStorage.getItem(this.userId);
    if (!ml) {
      let allData = localStorage.getItem("companyUsersList");
      let dt = JSON.parse(allData);
      dt.forEach((my, index) => {
        if (my.email === this.userId) {
          ml = JSON.stringify(my);
          sessionStorage.setItem(this.userId, ml);
        }
      });
    }

    this.userDetails = JSON.parse(ml);
    this.currentRoleCategory = JSON.parse(ml).rolesCategory;
    this.currentId = JSON.parse(ml).ownerId;

    this.$eventHub.$on("company", (company) => {
      this.company = company;
    });
    if (this.$route.query.companyId) {
      this.getBranches();
      this.getRoleGroups();
      this.getUserRoles();
    }
  },
  watch: {
    branches() {
      const filteredBranches = this.branches.filter((branch) => {
        return branch.id === this.userDetails.ownerId;
      });
      this.branchName = filteredBranches.length
        ? filteredBranches[0].name
        : null;
    },
    company(company) {
      if (company !== null) {
        this.getBranches();
        this.getRoleGroups();
        this.getUserRoles();
      }
    },
    groups: {
      handler() {
        this.groupId = this.groups.filter(
          (group) => group.name === this.userDetails.rolesCategory
        )[0].name;
      },
      deep: true,
    },
    groupRoles() {
      this.getUserRoles();
    },
    selectAll(value) {
      let selected = [];
      let combinedArray = [...this.options, ...this.options2, ...this.options3];
      if (!value) {
        this.selected = selected;
        this.tags = selected;
        return;
      }
      if (value) {
        combinedArray.forEach(function (opt) {
          selected.push(opt.text);
        });
        this.selected = selected;
        this.tags = selected;
      }
    },
    groupId() {
      this.getGroupRoles();
      if (this.groupId !== "Company") {
        this.getCategotyLists();
      }
    },
    tags: {
      handler(newTags, oldTags) {
        let newSelectedArray = [];
        if (newTags.length == this.combinedOptions.length) {
          document.querySelector("#selectAllCheckbox").checked = true;
        } else {
          document.querySelector("#selectAllCheckbox").checked = false;
        }
        try {
          if (newTags[0].tiClasses) {
            newTags.forEach((tg) => {
              newSelectedArray.push(tg.text);
            });
          } else {
            newTags.forEach((tg) => {
              newSelectedArray.push(tg);
            });
          }
          if (newTags.length < 1) {
            newSelectedArray = [];
          }
        } catch {
          newSelectedArray = [];
        }
        this.selected = newSelectedArray;
      },
      deep: true,
    },
  },
  computed: {
    userName() {
      return `${this.userDetails.firstName} ${this.userDetails.lastName}`;
    },
    filteredList() {
      const sortedList = [...this.options];
      sortedList.sort((a, b) => {
        return a.name > b.name ? 1 : -1;
      });
      return sortedList.filter((ch, i) =>
        ch.text.toLowerCase().includes(this.searchInp.toLowerCase())
      );
    },
    filteredList2() {
      const sortedList = [...this.options2];
      sortedList.sort((a, b) => {
        return a.name > b.name ? 1 : -1;
      });
      return sortedList.filter((ch, i) =>
        ch.text.toLowerCase().includes(this.searchInp.toLowerCase())
      );
    },
    filteredList3() {
      const sortedList = [...this.options3];
      sortedList.sort((a, b) => {
        return a.name > b.name ? 1 : -1;
      });
      return sortedList.filter((ch, i) =>
        ch.text.toLowerCase().includes(this.searchInp.toLowerCase())
      );
    },
  },
  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  methods: {
    replaceSel() {
      console.log("changed select");
      this.replaceSelect = true;
    },
    removeUser() {
      const confirm = window.confirm(
        `Are you sure you want to remove this user ?`
      );
      if (!confirm) {
        return;
      }
      let data = {
        email: this.$route.query.username,
        roleCategory: this.userDetails.rolesCategory,
        id: this.userDetails.ownerId,
      };
      this.isRemoveBtnDisabled = true;
      $(".loader1").show();
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Company/RemoveUserFrom`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.branchName = null;
          $(".loader1").hide();
          this.isRemoveBtnDisabled = false;
          this.$toast.open({
            message: "User removed successfully",
            type: "success",
            duration: 3000,
          });
          this.$router.go(-1);
        })
        .catch((error) => {
          $(".loader1").hide();
          this.isRemoveBtnDisabled = false;
        });
    },
    getFunctionList() {
      this.funcListLoader = true;
      this.functionList = [];
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/FunctionList/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }/${this.userDetails.rolesCategory}`,
          configObject.authConfig()
        )
        .then((res) => {
          this.functionList = res.data;
          for (let list of this.functionList) {
            if (list.name.includes(this.userBranchName)) {
              this.listId = list.id;
              return;
            }
          }
          this.showRoles = true;
          this.showList = true;
          this.funcListLoader = false;
        })
        .catch((error) => {
          this.funcListLoader = false;
          this.showList = false;
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 3000,
          });
        });
    },
    //Changed from grouproles to group categories
    // `${configObject.apiBaseUrl}​/Role/GroupRoles/${this.groupId}`
    getGroupRoles() {
      this.groupRolesLoader = true;
      this.showList = false;
      this.axios
        .get(
          `${configObject.apiBaseUrl}​/GroupManagement/GetListOfRolesByCategory/${this.groupId}`,
          configObject.authConfig()
        )
        .then((res) => {
          this.groupRoles = res.data;
          this.showRoles = true;
          this.showList = true;
          this.groupRolesLoader = false;

          const data = res.data.filter((el) => el.name !== null);
          data.forEach((el) => {
            el.text = el.name;
            el.value = el.name;
          });
          let copiedResponse = [...data];
          let options = [];
          let options2 = [];
          let options3 = [];
          copiedResponse.forEach((br, index) => {
            let dataLengthFirstOneThird = copiedResponse.length / 3;
            if (index <= dataLengthFirstOneThird) {
              options.push(br);
            }
          });

          let twoThirdOfArr = copiedResponse.splice(
            copiedResponse.length / 3 + 1,
            copiedResponse.length - 1
          );
          twoThirdOfArr.forEach((br, index) => {
            let dataHalfList = parseInt(twoThirdOfArr.length / 2);
            if (index <= dataHalfList) {
              options2.push(br);
            } else {
              options3.push(br);
            }
          });

          this.options = options;
          this.options2 = options2;
          this.options3 = options3;

          this.combinedOptions = [...options, ...options2, ...options3];
        })
        .catch((error) => {
          this.showLoader = false;
          this.showList = false;
        });
    },
    //Changed from groups to categories
    // `${configObject.apiBaseUrl}/Role/Groups`
    getRoleGroups() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Role/Categories`,
          configObject.authConfig()
        )
        .then((res) => {
          let index = 0;
          res.data.sort((a, b) => {
            return a.name.toLowerCase() > b.name.toLowerCase()
              ? 1
              : b.name.toLowerCase() > a.name.toLowerCase()
              ? -1
              : 0;
          });
          // res.data.filter((group) => {
          //   // if (com.name !== "Company") {
          //   //   return true;
          //   // }
          //   return group.name !== "Company";
          // });
          // this.groups = res.data.filter((group) => group.name !== "Company");
          this.groups = res.data;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    //new endpoint for category list
    getCategotyLists() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/DealerBranchGroup/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }/${this.groupId}`,
          configObject.authConfig()
        )
        .then((res) => {
          let index = 0;
          res.data.sort((a, b) => {
            return a.name.toLowerCase() > b.name.toLowerCase()
              ? 1
              : b.name.toLowerCase() > a.name.toLowerCase()
              ? -1
              : 0;
          });
          this.categoryLists = res.data;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    validEmail(email) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return true;
      }
      return false;
    },
    updateUser($event) {
      $event.preventDefault();
      if (!this.userDetails.firstName) {
        this.$toast.open({
          message: this.$t("text.errors.firstNameMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.userDetails.lastName) {
        this.$toast.open({
          message: this.$t("text.errors.lastNameMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.userDetails.phoneNumber) {
        this.$toast.open({
          message: this.$t("text.errors.contactPhoneMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.newId || !this.userDetails.ownerId) {
        this.$toast.open({
          message: this.$t(`"Please Select a ${this.groupId}"`),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (
        this.userDetails.phoneNumber.length < 10 ||
        this.userDetails.phoneNumber.length > 13
      ) {
        this.$toast.open({
          message: this.$t("text.errors.shortPhoneNumber"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      let roles = [];
      this.combinedOptions.forEach((opt) => {
        if (this.selected.includes(opt.name)) {
          roles.push(opt.name);
        }
      });
      //group.id changed to group.name
      const roleCategory = this.groups.filter(
        (group) => group.name === this.groupId
      )[0].name;

      let data = {
        userName: this.$route.query.username,
        firstName: this.userDetails.firstName,
        lastName: this.userDetails.lastName,
        phoneNumber: this.userDetails.phoneNumber,
        forcePasswordChange: this.forcePasswordChange,
        accountStatus: this.userDetails.status,
        roles: roles,
        id: this.currentId,
        newId:
          this.newId !== "Please Select"
            ? this.newId
            : this.userDetails.ownerId,
        roleCategory: this.currentRoleCategory,
        newRoleCategory:
          this.groupId !== "select access level"
            ? this.groupId
            : this.userDetails.rolesCategory,
      };

      this.isButtonDisabled = true;
      $(".loader").show();
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Account/Update`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.$toast.open({
            message: `User (${this.userDetails.email}) has been updated successfully`,
            type: "success",
            duration: 5000,
          });
          this.$router.push({
            name: "company_users",
            query: this.$route.query.branchId
              ? {
                  branchId: this.$route.query.branchId,
                }
              : { companyId: this.$route.query.companyId },
          });

          $(".loader").hide();
          this.isButtonDisabled = false;
        })
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
        });
    },
    getBranches() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/Branches/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          configObject.authConfig()
        )
        .then((response) => {
          this.branches = response.data;
        })
        .catch((error) => {});
    },
    getUserRoles() {
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Account/roles/${this.$route.query.username}`,
          {},
          configObject.authConfig()
        )
        .then((res) => {
          this.userRoles = res.data;

          const data = [];
          this.groupRoles.forEach((el) => {
            data.push(el.name);
          });
          let tags = [];
          let selected = [];
          res.data.forEach((role) => {
            if (data.includes(role.roleName)) {
              tags.push(role.roleName);
              selected.push(role.roleName);
            }
          });
          this.tags = tags;
          this.selected = selected;
        })
        .catch((error) => {});
    },
    changeStatus(status) {
      this.status = status;
    },
    checkAll(e) {
      let selected = [];
      if (e.target.checked) {
        this.combinedOptions.forEach((el) => {
          selected.push(el.text);
        });
      }
      this.selected = selected;
      this.tags = selected;
    },
    toggleBranchListDropdown() {
      this.showBranchListDropDown = !this.showBranchListDropDown;
    },
    toggleChckBox($event) {
      if ($event.target.checked) {
        const getIndex = this.selected.indexOf($event.target.value);

        if (getIndex === -1) {
          this.selected.push($event.target.value);
          this.tags.push($event.target.value);
        }
      } else {
        document.querySelector("#selectAllCheckbox").checked = false;
        const getIndex = this.selected.indexOf($event.target.value);
        if (getIndex > -1) {
          this.selected.splice(getIndex, 1);
          this.tags.splice(getIndex, 1);
        }
      }
      if (this.selected.length == this.combinedOptions.length) {
        document.querySelector("#selectAllCheckbox").checked = true;
      }
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {},
    getCompanyUsers() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/Users/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          configObject.authConfig()
        )
        .then((response) => {
          response.data.sort((a, b) => {
            return a.email > b.email ? 1 : b.email > a.email ? -1 : 0;
          });
          response.data.forEach((user, index) => {
            user.index = index + 1;
            user.branchManaged =
              user.role.toLowerCase() == "companyadmin" ||
              user.role.toLowerCase() == "IndustryManager"
                ? null
                : user.branchRoles.map((cur) => cur.branchName).join(", ");
            user.role =
              user.role.toLowerCase() == "companyadmin"
                ? "Company Admin"
                : user.role.toLowerCase() == "IndustryManager"
                ? "Industry Admin"
                : user.role.toLowerCase() == "branch manager"
                ? "Branch Manager"
                : user.role;
            if (user.role == "") {
              user.role = "Branch Manager";
            }
          });
          this.usersCount = response.data.length;
          this.showLoader = false;
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
  },
};
</script>

<style></style>
